import PromptTable from "@/components/templates/PromptTable";

const Prompts = () => <PromptTable />;

export default Prompts;
